import { configureStore } from "@reduxjs/toolkit";
import flowSlice from "./flowSlice";

const appStore = configureStore({
  reducer: {
    flow: flowSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // ← Disables the warning
    }),
});

export default appStore;
